import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_3 = { class: "row spaced" }
const _hoisted_4 = { class: "menu-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Maud Gourdon", -1)
const _hoisted_6 = ["aria-expanded"]
const _hoisted_7 = {
  id: "menu-items",
  class: "menu-items"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", null, "About", -1)
const _hoisted_9 = { class: "content col-12 col-md" }

import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { MaudArticle } from "./types/article"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const menuOrder = computed(() => store.state.MenuOrder);

// Only phones fold the menu; picking a work should show the work, not the list.
const menuOpen = ref(false);
const route = useRoute();
watch(() => route.fullPath, () => {
  menuOpen.value = false;
});

function getArticle(id: number)  {
  return store.state.articles.find((art: MaudArticle) => art.id === id);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["menu col-12 col-md-auto", { open: menuOpen.value }])
      }, [
        _createElementVNode("header", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "clickable"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            type: "button",
            class: "menu-toggle",
            "aria-controls": "menu-items",
            "aria-expanded": menuOpen.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (menuOpen.value = !menuOpen.value))
          }, _toDisplayString(menuOpen.value ? 'Close' : 'Menu'), 9, _hoisted_6)
        ]),
        _createElementVNode("nav", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuOrder), (obj) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "visible",
              key: getArticle(obj).id
            }, [
              _createVNode(_component_router_link, {
                to: '/article/' + getArticle(obj).id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getArticle(obj).title), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128)),
          _createVNode(_component_router_link, {
            class: "about",
            to: "/about"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ], 2),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

})